import { classnames } from 'Utils/classnames/classnames.utils';

const getSmallStyles = (isExclusiveCollection) => {
  return {
    thTitle: 'font-brand mt-40 mb-0 text-center text-ultramarine',
    thList: classnames('flex text-10', {
      'flex-wrap': isExclusiveCollection,
    }),
    thListItem: classnames(
      'flex-none px-5',
      { 'w-1/4': !isExclusiveCollection },
      { 'w-1/2': isExclusiveCollection },
    ),
    thItem: classnames(
      'flex h-full flex-col items-center justify-center overflow-hidden rounded-12 border-lightGrey p-10 px-0 text-center font-sans font-bold leading-normal',
      { 'border-1 text-10 text-black': !isExclusiveCollection },
      { 'border-0 text-12 text-ultramarine': isExclusiveCollection },
    ),
    thIcon: 'mb-10',
    thIconWidth: isExclusiveCollection ? '3.6em' : '2em',
    thText: 'font-bold leading-tight w-full',
    thCTA: 'mt-5 text-10',
  };
};

export const themes = (isExclusiveCollection) => {
  const small = getSmallStyles(isExclusiveCollection);
  return {
    default: small,
    medium: {
      ...small,
      thTitle: classnames(small.thTitle, 'sm:mt-50'),
      thListItem: classnames(
        small.thListItem,
        { 'sm:w-1/5': !isExclusiveCollection },
        { 'sm:w-1/2': isExclusiveCollection },
      ),
      thItem: classnames(small.thItem, 'sm:px-5 md:px-10 md:py-20 md:text-12'),
    },
    large: {
      thTitle: classnames(small.thTitle, 'sm:mt-50'),
      thList: small.thList,
      thListItem: classnames(
        small.thListItem,
        { 'md:w-1/6': !isExclusiveCollection },
        { 'sm:w-1/3': isExclusiveCollection },
      ),
      thItem: classnames(small.thItem, 'sm:px-5 md:px-10 md:py-20 md:text-12'),
      thIcon: small.thIcon,
      thIconWidth: small.thIconWidth,
      thText: small.thText,
      thCTA: small.thCTA,
    },
    column: {
      thList: 'p-0 m-0 list-none',
      thItem: 'border-none text-14 mt-10',
      thIcon: 'mr-20 text-black',
      thText: 'mr-5',
    },
  };
};
